/* © CNES */
import { SatelliteDataItem } from '../../../../models/SatelliteDataItem';
import { ContextType } from './../../../../context/ConfigContext';
/**
 * Build Results Sets for satellite and product Type (level).
 * @returns Set<string>[]
 */
export const buildResultsSets = (
  context: ContextType,
  collectionsForCurrentPage: SatelliteDataItem[]
) => {
  const levelSet = new Set(context.productsAdded.levelSet);
  collectionsForCurrentPage.forEach((collection) =>
    levelSet.add(collection.level)
  );

  const satelliteSet = new Set(context.productsAdded.satelliteSet);
  collectionsForCurrentPage.forEach((collection) =>
    satelliteSet.add(collection.satellite)
  );

  return [levelSet, satelliteSet];
};

/**
 * Add All Products From a clicked ProductType.
 * @param products string[] products names.
 * @param productTypeClicked string product Type Clicked.
 * @returns string[] products.
 */
export const addAllProductsFromProductType = (
  products: string[],
  productTypeClicked: string,
  collectionsFromBack: SatelliteDataItem[]
) => {
  return [
    ...products.concat(
      collectionsFromBack
        .filter((collection) => collection.level === productTypeClicked)
        .map((collection) => collection.title)
    ),
  ];
};

/**
 * Remove All Products From a clicked node.
 * @param products string[] products names.
 * @param nodeClicked string The node clicked in tree.
 * @param nodeType 'level' | 'satellite' The node Type.
 * @param collectionsFromBack SatelliteDataItem[] The collections From Back.
 * @param context ContextType The context Type.
 * @returns string[] products and productsRemoved.
 */
export const removeAllProductsFromNode = (
  products: string[],
  nodeClicked: string,
  nodeType: 'level' | 'satellite',
  collectionsFromBack: SatelliteDataItem[],
  context: ContextType
) => {
  const productsRemoved = collectionsFromBack
    .filter((collection) => collection[nodeType] === nodeClicked)
    .map((collection) =>
      products.filter(
        (product) =>
          product === collection.title &&
          context.productsAdded?.products?.includes(product)
      )
    )
    .flat();

  collectionsFromBack
    .filter((collection) => collection[nodeType] === nodeClicked)
    .forEach(
      (collection) =>
        (products = products.filter((product) => product !== collection.title))
    );

  return [productsRemoved, products];
};

/**
 * Retrieves the value of the "href" key for the object that has "data" in its roles and no application/xml in its type.
 * @param assets
 * @returns
 */
export const getProductHREF = (assets: { [key: string]: any } | undefined) => {
  if (!assets) {
    return '';
  }
  return (
    Object.values(assets).find(
      (asset): asset is { href: string; roles: string[] } => {
        return (
          asset.roles.includes('data') &&
          !asset.type.includes('application/xml')
        );
      }
    )?.href ?? ''
  );
};
